
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Poveste',
	'noDashboardFound': 'Nu a putut fi extrasă povestea. Fie nu mai există, fie nu aveţi suficiente privilegii pentru a-l vizualiza.',
	'noDashboardCapability': 'Nu aveţi capabilitatea de a folosi poveşti',
	'noDashboardPermision': 'Nu aveţi suficiente privilegii pentru a vizualiza această poveste',
	'defaultName': 'Poveste nouă',
	'storyProperties': 'Proprietăţi poveste',
	'createAvDataStoryLabel': 'Poveste',
	'createAvSlideShowLabel': 'Expunere de diapozitive',
	'createAvPanAndZoomLabel': 'Tur ghidat',
	'dashboard_save_success': 'Povestea a fost salvată.',
	'cmEmptySelection': 'Povestea a fost ştearsă. Încercaţi să o salvaţi ca o poveste nouă.',
	'createStoryTitle': 'Creare poveste',
	'transitionStyleTitle': 'Stil tranziţie',
	'createButton': 'Creare',
	'cancelButton': 'Renunţare',
	'dashboardResetTitle': 'Resetare poveste',
	'dashboardResetMessage': 'Sunteţi sigur că vreţi să resetaţi toate modificările aplicate acestei poveşti?',
	'dashboardResetToast': 'Povestea dumneavoastră a fost resetată.',
	'filter_drag_and_drop_all_tabs': 'Trageţi şi plasaţi date aici pentru a filtra toate scenele.',
	'filter_drag_and_drop_current_tab': 'Trageţi şi plasaţi date aici pentru a filtra această scenă.',
	'filterIconLabel_Global': 'Toate scenele',
	'filterIconLabel_Tab': 'Această scenă',
	'filterIconTooltip_Global': 'Toate scenele',
	'filterIconTooltip_Tab': 'Această scenă',
	'filterOverflowMenu_Global': 'Meniu depăşire toate scenele',
	'filterOverflowMenu_Tab': 'Meniu depăşire această scenă',
	'renameScene': 'Redenumire scenă',
	'duplicateScene': 'Duplicare scenă',
	'deleteScene': 'Ştergere scenă',
	'editTimelineHighlight': 'Editare evidenţiere',
	'deleteTimelineHighlight': 'Ştergere evidenţiere',
	'filter_includesAll': 'Include tot',
	'timeline_highlight_moved_to': 'Evidenţierea liniei de timp %{id} a fost mutată la %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Selectare',
	'newDefaultStoryName': 'Poveste: %{modelName}',
	'exportLabel': 'Salvare',
	'exportAsLabel': 'Salvare ca:',
	'exportDialogTitle': 'Salvare ca poveste',
	'exportDialogFooter': 'Butoane de salvare şi anulare',
	'loadAfterExportLabel': 'Deschidere poveste după salvare',
	'selectTemplateLabel': 'Selectare şablon',
	'outOfBoundsWarningMessage': 'Unele widget-uri tablou de bord se află în afara grilei şi este posibil să nu fie afişate corect după export.',
	'emptyExploreCardsWarningMessage': 'cardurile goale au fost şterse în timpul salvării ca poveste.',
	'dashboard_export_success': 'Tabloul dumneavoastră de bord a fost salvat cu succes ca poveste.',
	'explore_export_success': 'Explorarea dumneavoastră a fost salvată cu succes ca o poveste.',
	'toastUpgradeDone': 'S-a făcut upgrade poveştii dumneavoastră. Salvaţi acum pentru a menţine performanţa optimă.',
	'navigationMarker': 'Reper navigare',
	'navigateMarkers': 'Repere navigare',
	'navNextMarker': 'Reper următor',
	'navPrevMarker': 'Reper anterior',
	'navPrevMarkerAbbreviated': 'Reper ant.',
	'timelineSettingsButton': 'Opţiuni de redare',
	'autoPlay': 'Redare toate scenele',
	'loop': 'Buclă',
	'refreshData': 'Reîmprospătare la pornire',
	'slideshowLabel': 'Expunere diapozitive',
	'panAndZoomLabel': 'Tur ghidat',
	'slideShowLayoutLabel': 'Dispunere expunere diapozitive',
	'panAndZoomLayoutLabel': 'Dispunere tur ghidat',
	'panAndZoomLayoutFooter': 'O dispunere de tur ghidat este o colecţie de scene pe o singură canava. Când rulaţi acest tip de poveste, prezentarea face zoom şi panoramare pe fiecare scenă individuală în ordine secvenţială. Aceasta diferă de o dispunere de prezentare de diapozitive unde fiecare scenă este prezentată pe o nouă canava. Dispunerea de tur ghidat cu trei scene conectate cu linii vă permite să creaţi o secvenţă orizontală de scene. Acest lucru este util pentru afişarea unei cronologii.',
	'PanAndZoomLayout1': '5 imagini aranjate într-o formă dreptunghiulară',
	'PanAndZoomLayout2': '4 imagini aranjate în formă de scară începând de la stânga la dreapta',
	'PanAndZoomLayout3': '6 imagini aranjate într-o formă dreptunghiulară',
	'PanAndZoomLayout4': '7 imagini aranjate într-o formă dreptunghiulară, cu 6 imagini mici în partea de sus şi o imagine mare în partea de jos',
	'PanAndZoomLayout5': '3 scene aranjate cu 2 scene mici în partea de sus şi 1 scenă mare în partea de jos',
	'PanAndZoomLayout6': 'O secvenţă de 4 scene aranjate orizontal',
	'pageSelectWarning': 'Vă rugăm să selectaţi o scenă.',
	'noSceneTransitionLabel': 'Fără',
	'sceneTransitionPropertyLabel': 'Tranziţie scenă',
	'animatedPathSceneTransitionLabel': 'Cale animată',
	'sweepSceneTransitionLabel': 'Glisare',
	'storyTypeLabel': 'Tip poveste',
	'layoutLabel': 'Dispunere',
	'tabName_animation': 'Animaţie',
	'propAniAnimation': 'Animaţie',
	'propAniTypeEntrance': 'Animaţie la intrare',
	'propAniDirectionIn': 'Direcţie la intrare',
	'propAniTypeExit': 'Animaţie la ieşire',
	'propAniDirectionOut': 'Direcţie la ieşire',
	'propAniDirection': 'Direcţie',
	'propAniEntrance': 'Intrare',
	'propAniTypeEntranceSlideIn': 'Glisare',
	'propAniTypeEntranceFadeIn': 'Estompare',
	'propAniTypeEntrancePivotIn': 'Pivotare',
	'propAniTypeEntranceScaleIn': 'Scalare',
	'propAniTypeEntranceShrinkIn': 'Restrângere',
	'propAniDirectionInLeft': 'De la stânga',
	'propAniDirectionInRight': 'De la dreapta',
	'propAniDirectionInTop': 'Din partea de sus',
	'propAniDirectionInBottom': 'Din partea de jos',
	'propAniExit': 'Ieşire',
	'propAniTypeExitSlideIn': 'Anulare glisare',
	'propAniTypeExitFadeIn': 'Anulare estompare',
	'propAniTypeExitPivotOut': 'Anulare pivotare',
	'propAniTypeExitScaleIn': 'Anulare scalare',
	'propAniTypeExitExpandOut': 'Anulare expandare',
	'propAniDirectionOutLeft': 'La stânga',
	'propAniDirectionOutRight': 'La dreapta',
	'propAniDirectionOutTop': 'În sus',
	'propAniDirectionOutBottom': 'În jos',
	'propAniEntranceTime': 'Începere la (secunde):',
	'propAniExitTime': 'Terminare la (secunde):',
	'animationNoEntranceText': 'Animaţia de intrare nu va apărea dacă widget-ul este la începutul scenei.',
	'animationNoExitText': 'Animaţia de ieşire nu va apărea dacă widget-ul este la sfârşitul scenei.',
	'propAniTypeDataEntrance': 'Intrare date',
	'propAniRevealDuration': 'Durată animaţie de intrare',
	'timelineAnimationProperties': 'Deschidere proprietăţi animaţie',
	'scenesPropertiesSection': 'Scene',
	'editStoryCoachMarkTitle': 'Editare poveste',
	'editStoryCoachMarkContents': 'Faceţi clic pe pictograma stilou pentru a edita această poveste.',
	'addDataStoryCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date în povestea dumneavoastră.',
	'expandSceneCoachmarkTitle': 'Deschidere linie de timp',
	'expandSceneCoachmarkContents': 'Animaţi o scenă prin ajustarea vizibilităţii obiectelor bazate pe timp şi durată.',
	'overviewCoachmarkTitle': 'Privire generală asupra scenelor',
	'overviewCoachmarkContents': 'Utilizaţi privirea generală asupra scenelor la începutul şi sfârşitul scenariului dumneavoastră pentru a afişa imaginea mare a tuturor scenelor. Dintr-o privire generală asupra scenelor, faceţi clic şi trageţi o scenă pentru interschimbarea ei altă scenă. Puteţi afişa sau ascunde privirea generală asupra scenelor în proprietăţile scenariului.',
	'animatedPathCoachmarkTitle': 'Cale animată',
	'animatedPathCoachmarkContents': 'Pentru a anima un obiect dintr-o scenă în alta, duplicaţi o scenă cu un obiect. Apoi mutaţi, redimensionaţi sau rotiţi obiectul duplicat în noua scenă.',
	'propShowStoryOverviewFirstSlide': 'Afişarea tuturor scenelor la început',
	'propShowStoryOverviewLastSlide': 'Afişarea tuturor scenelor la sfârşit',
	'storySceneSingleCountLabel': '1 scenă',
	'storySceneCountLabel': '%{count} scene',
	'storySceneRangeCountLabel': 'Scena %{index} din %{count}',
	'storySceneExpand': 'Deschidere linie de timp',
	'storySceneActionMenu': 'Meniu opţiuni de lansare scenă',
	'timelineRightContainerLabel': 'Grup de control butoane linie de timp',
	'timelineViewLabel': 'Linie de timp',
	'timelineZoomFit': 'Panoramare pentru a se potrivi',
	'timelineZoomIn': 'Mărire',
	'timelineZoomOut': 'Micşorare',
	'timelinePositionIndicator': 'indicator de poziţie în linia de timp la %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'mutare stânga indicator poziţie în linia de timp, la %{position}',
	'timelinePositionIndicatorMoveRightTo': 'mutare dreapta indicator poziţie în linia de timp, la %{position}',
	'sceneStart': 'Salt la începutul scenei la %{position}',
	'sceneEnd': 'Salt la sfârşitul scenei la %{position}',
	'timelineHighlightTitle': 'Evidenţiere',
	'addTimelineHighlight': 'Adăugare evidenţiere',
	'addSceneBtnTitle': 'Adăugare scenă nouă cu şablon implicit',
	'addSceneChevronBtnTitle': 'Alegere şablon',
	'timelinePlay': 'Redare',
	'timelinePause': 'Pauză',
	'sceneNavigation': 'Navigare scene',
	'navNextScene': 'Scenă următoare',
	'navPrevScene': 'Scenă anterioară',
	'navPrevSceneAbbreviated': 'Scenă ant.',
	'navExitFullScreen': 'Ieşire din ecran complet',
	'navToggleOverview': 'Comutare privire generală',
	'rowNumber': 'Rândul %{number}',
	'overviewBtnLabel': 'Privire generală',
	'sceneListStart': 'Început privire generală',
	'sceneListEnd': 'Sfârşit privire generală',
	'timelineLeftHandle': 'handle stânga pentru %{name}',
	'timelineRightHandle': 'handle dreapta pentru %{name}',
	'timelineLeftHandleNoTitle': 'handle stânga',
	'timelineRightHandleNoTitle': 'handle dreapta',
	'timelineMoveLeft': 'Mutare stânga %{object}',
	'timelineMoveRight': 'Mutare dreapta %{object}',
	'timelineMoveWidget': 'widget-ul linie de timp a fost mutat la %{newStartTime} şi %{newEndTime}',
	'timelineMoveWidgetStartTime': 'timpul de pornire al widget-ului linie de timp a fost modificat la %{newStartTime}',
	'timelineMoveWidgetEndTime': 'timpul de terminare al widget-ului linie de timp a fost modificat la %{newEndTime}',
	'timelineMoveWidgetDown': 'widget-ul linie de timp a fost mutat jos',
	'timelineMoveWidgetUp': 'widget-ul linie de timp a fost mutat sus',
	'addSceneTitle': 'Adăugare scenă',
	'blankSceneLayout': 'Necompletat',
	'titleSceneLayout': 'Titlu cu subtitlu',
	'sceneLayout1': 'Titlu cu text lângă o vizualizare',
	'sceneLayout2': 'Titlu cu o vizualizare',
	'sceneLayout3': 'Titlu cu două vizualizări',
	'sceneLayout4': 'Scop general',
	'sceneLayout5': 'Fără titlu cu text lângă o vizualizare',
	'sceneLayout6': 'Scop general 2 pe 2',
	'sceneLayout7': 'Scop general 2 lângă 1',
	'sceneLayout8': 'Scop general 1 lângă 2',
	'sceneLayout9': 'Scop general 1 peste 2',
	'sceneLayout10': 'Scop general 2 peste 1',
	'sceneLayout11': 'Scop general 4 peste 1',
	'sceneLayout12': 'Scop general 1 peste 1 lângă 2 pe 2 peste 1',
	'titleWidgetPlaceholderText': 'Introduceţi titlul aici',
	'subtitleWidgetPlaceholderText': 'Introduceţi subtitlul aici',
	'createStoryViewTitle': 'Creare poveste',
	'defaultStoryName': 'Poveste nouă',
	'screenshot_label': 'Povestea %{title}',
	'screenshot_label_scene': 'Scena %{sceneTitle} din povestea %{title}',
	'filmstripHandleOpenLabel': 'Deschidere selector scene',
	'filmstripHandleCloseLabel': 'Închidere selector scene'
});
